// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"FormStack_breadcrumbs__B7CFa","wrapper":"FormStack_wrapper__C4ob+","formList":"FormStack_formList__k8rD7"};